import './setPublicPath'
import Vue from 'vue'
import wrap from '@vue/web-component-wrapper'

// runtime shared by every component chunk
import '/opt/atlassian/pipelines/agent/build/app/packages/eleasa_sitepackage/Build/node_modules/css-loader/dist/runtime/api.js'
import '/opt/atlassian/pipelines/agent/build/app/packages/eleasa_sitepackage/Build/node_modules/vue-style-loader/lib/addStylesShadow.js'
import '/opt/atlassian/pipelines/agent/build/app/packages/eleasa_sitepackage/Build/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js'

import calculatorVelo from '~root/src/components/Calculators/VeloWebcomponent.vue?shadow'
window.customElements.define('calculator-velo', wrap(Vue, calculatorVelo))